import React, { useEffect, useState } from "react";
import { Button, Typography, message, Image, Form, Select, Progress } from "antd";
import { authSVC, categorySVC } from "../../services";
import { useB2BContext } from "../../context/ContextB2B";
import DataTable from "../../components/dataTable/b2b/DataTable";
import { Spin } from "antd";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import useSWR from "swr";
import * as Cookie from "universal-cookie";
import { Checkbox } from "antd";
import { Option } from "antd/es/mentions";
import "./Employees.scss";
import { AppModal, AppUpload } from "../../components/common";

const cookie = new Cookie.default();
const cachedToken = cookie.get("userAuthTokenAdmin");
const { Text } = Typography;

interface Contentdata {
  _id: string;
  full_name: string;
  email: string;
  user_type: string;
  company: string;
  department: string;
}

const fetcherOne = (url: any) =>
  axios
    .get(url, {
      headers: {
        Authorization: `Bearer ${cachedToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => res?.data?.data);

function Employees() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const { getUserByID, setAllPackageList, allPackageList } = useB2BContext();
  const [editContent, setEditContent] = useState<Contentdata>({
    _id: "", full_name: "", email: "", user_type: "", company: "", department: "",
  });
  const [contentData, setContentData] = useState<any[]>([]);
  const [employeCountData, setEmployeCountData] = useState<any[]>([]);
  const [disableAddBtn, setDisableAddBtn] = useState(false);
  const [userPackage, setUserPackage] = useState("");
  const [isLoding, setIsLoding] = useState(false);
  const [isDownloadLoding, setIsDownloadLoding] = useState(false);
  const [csvFile, setCSVFile] = useState<any>(null);
  const navigate = useNavigate();
  const [csvUploadPopup, setCsvUploadPopup] = useState(false);
  const [userLimitOver, setUserLimitOver] = useState(false);
  const [packageId, setPackageId] = useState<any>();
  const [packageName, setPackageName] = useState<any>();
  const [department, setDepartment] = useState<any>();
  const [packageList, setPackageList] = useState([]);
  const [allDepartment, setAllDepartment] = useState<any>();
  const [csvNotAllowed, setCSVNotAllowed] = useState<any>(false);
  const [csvError, setCsvError] = useState<any>();

  useEffect(() => {
    console.log(contentData, "contentData");
    console.log(employeCountData, "employeCountData");
  }, [contentData, employeCountData]);

  const CancelCsvUploadPopup = () => setCsvUploadPopup(false);
  const UserLimitOverCancel = () => setUserLimitOver(false);

  const handleFileChange = (event: any) => {
    const file = event.target.files[0];
    if (file) {
      const MAX_FILE_SIZE = 10 * 1024 * 1024;
      if (file.size > MAX_FILE_SIZE) {
        message.error("File size should not exceed 10MB");
        event.target.value = "";
        return;
      }
      const validCSVTypes = ["text/csv", "application/csv", "text/plain", "application/vnd.ms-excel", ""];
      const isCSVExtension = file.name.toLowerCase().endsWith('.csv');
      if (validCSVTypes.includes(file.type) && isCSVExtension) {
        setCSVFile(file);
      } else {
        message.error("Please upload a valid CSV file with .csv extension.");
      }
    }
  };

  const UploadCSVFile = async () => {
    const formData: any = new FormData();
    formData.append("package_name", packageName);
    formData.append("department", department);
    formData.append("package_id", packageId);
    formData.append("csvFile", csvFile);
    console.log(formData, "fff");
    setIsLoding(true);
    await authSVC
      .UploadCompanyCSV(formData)
      .then((res: any) => {
        if (res.data.success) {
          getEmployees();
          setIsLoding(false);
          setCSVFile(null);
          setPackageName("");
          setDepartment("");
          setPackageId("");
          setCsvUploadPopup(false);
          message.success("Users added successfully from CSV file.");
          setTimeout(() => { window.location.reload(); }, 1000);
        } else {
          message.error(res.data.error);
        }
      })
      .catch((err: any) => {
        setCSVNotAllowed(true);
        setIsLoding(false);
        setTimeout(() => { setCSVNotAllowed(false); }, 3000);
        setCsvError(err?.response?.data?.error);
        console.log(err?.response?.data?.error, "fff4444");
      });
  };

  const getEmployees = async () => {
    if (getUserByID?.email) {
      await authSVC
        .getCompanyuser()
        .then((res: any) => {
          setContentData(res.data?.data);
          setEmployeCountData(res?.data?.package_employee_statistics);
        })
        .catch((err: any) => { message.error(err.message); });
    }
  };

  useEffect(() => { getEmployees(); }, [getUserByID]);

  const API_PATH = process.env.REACT_APP_API_URL;

  useEffect(() => { getDepartments(getUserByID); }, [getUserByID]);

  const getDepartments = (getUserByID: any) => {
    if (getUserByID?.company) {
      authSVC
        .getCompanyDepartments(getUserByID?.company)
        .then((res: any) => setAllDepartment(res.data.data))
        .catch((err: any) => { message.error(err.message); });
    }
  };

  useEffect(() => { setUserPackage(getUserByID?.package_name); }, [getUserByID]);

  const deleteUser = (id: string) => {
    console.log(id);
    authSVC
      .DeleteUser(id)
      .then((response) => {
        message.success("Delete successfully");
        getEmployees();
      })
      .catch((error) => { console.error("Error deleting resource:", error); });
  };

  const editCategory = (id: string) => {
    const findByid = contentData.find((item: any) => item._id === id ? item : null);
    setEditContent({
      _id: findByid?._id,
      full_name: findByid?.full_name ?? findByid?.first_name,
      email: findByid?.email,
      user_type: findByid?.user_type,
      company: findByid?.company,
      department: findByid?.department,
    });
  };

  const downloadFile = () => {
    const headers = ["Name", "Email", "Department"];
    const rows = contentData && contentData?.map((row: any) => [row.full_name, row.email, row.department]);
    const csvContent = [headers, ...rows].map((e) => e.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "Employee_Data.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleChange = (value: string) => setDepartment(value);

  const handleSelectedPackage = (packageValue: any) => {
    console.log(`Value for package ${JSON.parse(packageValue)}`);
    const value = JSON.parse(packageValue);
    if (value) {
      console.log(`Setting ${value._id} and ${value.package}`);
      setPackageId(value._id);
      setPackageName(value.package);
    }
  };

  useEffect(() => {
    console.log(`Packagessss list`, getUserByID?.company_id?.package);
    setPackageList(getUserByID?.company_id?.package);
  }, [getUserByID]);

  const handleDownload = () => {
    const csvData = [["Full Name", "Email Id", "Occupation", "Marital Status", "Gender"]];
    const csvContent = csvData.map((row) => row.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.download = "EmployeeFormatExample.csv";
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="employees-page">

      {/* ── Page header ──────────────────────────────────────────── */}
      <div className="employees-page__header">
        <div className="employees-page__title-block">
          <h1 className="employees-page__title">Manage Employees</h1>
          <p className="employees-page__subtitle">Add, manage and track your team members.</p>
        </div>

        {/* ── Action buttons ────────────────────────────────────── */}
        {getUserByID && (
          allDepartment?.length === 0 ? (
            <button
              className="emp-btn emp-btn--primary"
              onClick={() => navigate("/adddepartments")}
            >
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
                <path d="M7.5 1v13M1 7.5h13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
              Add Department
            </button>
          ) : (
            <div className="employees-page__actions">
              <button
                className="emp-btn emp-btn--primary"
                onClick={() => navigate("/addemployees")}
                disabled={getUserByID?.is_payment === false ? true : disableAddBtn ? true : false}
              >
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
                  <path d="M7.5 1v13M1 7.5h13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
                Add New Employee
              </button>

              <button
                className="emp-btn emp-btn--secondary"
                onClick={() => setCsvUploadPopup(true)}
              >
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
                  <path d="M7.5 10V2M4 7l3.5 3.5L11 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M1 13h13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
                Bulk Users Upload
              </button>

              <button
                className="emp-btn emp-btn--ghost"
                disabled={getUserByID?.is_payment === false ? true : isDownloadLoding}
                onClick={downloadFile}
              >
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
                  <path d="M7.5 10V2M4 7l3.5 3.5L11 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M1 13h13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
                Export Users Data
              </button>
            </div>
          )
        )}
      </div>

      {/* ── Employee count stats ────────────────────────────────── */}
      {employeCountData && employeCountData.map((item, idx) => {
        const pct = (item.total_active_user / item.total_unit_employee) * 100;
        return (
          <div key={idx} className="emp-stat-card">
            <div className="emp-stat-card__top">
              <div className="emp-stat-card__counts">
                <span className="emp-stat-card__numbers">
                  {item.total_active_user} <em>of</em> {item.total_unit_employee}
                </span>
                <span className="emp-stat-card__label">users added</span>
              </div>
              <span className="emp-stat-card__package-badge">{item.package_name}</span>
            </div>
            <Progress
              percent={pct}
              showInfo={false}
              strokeColor="#b21e49"
              trailColor="#e8ebf5"
              strokeWidth={8}
            />
          </div>
        );
      })}

      {/* ── DataTable — DO NOT TOUCH ────────────────────────────── */}
      <DataTable
        email={getUserByID?.email}
        deleteuser={deleteUser}
        editContent={editCategory}
        setshowModel={setIsModalOpen}
        setEditable={setIsEditable}
        isOpen={isModalOpen}
        contentData={contentData}
      />

      {/* ── CSV Upload Modal ─────────────────────────────────────── */}
      <AppModal
        title="Import CSV"
        open={csvUploadPopup}
        onCancel={CancelCsvUploadPopup}
        className="emp-modal"
      >
        <div className="emp-modal__inner">
          {/* <div className="emp-modal__icon-wrap">📊</div> */}
          
          <p className="emp-modal__desc">Upload employee data in bulk using a CSV file.</p>

          {/* Step 1 */}
          <div className="emp-modal__step-header">
            <span className="emp-modal__step-num">1</span>
            <span className="emp-modal__step-label">Download Template</span>
          </div>
          <button className="emp-btn emp-btn--ghost emp-btn--full" onClick={handleDownload}>
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
              <path d="M7.5 10V2M4 7l3.5 3.5L11 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M1 13h13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
            CSV Template
          </button>

          {/* Step 2 */}
          <div className="emp-modal__step-header">
            <span className="emp-modal__step-num">2</span>
            <span className="emp-modal__step-label">Upload Employee Data</span>
          </div>

          {allPackageList && (
            <Form.Item name="package_name" rules={[{ required: true, message: "Please input Package Name!" }]} className="emp-modal__form-item">
              <Select
                className="emp-modal__select"
                style={{ width: "100%" }}
                placeholder="Select employee package"
                optionFilterProp="children"
                onChange={handleSelectedPackage}
              >
                {packageList?.map((packageDetail: any) => (
                  <option key={packageDetail.package_id._id} value={JSON.stringify(packageDetail.package_id)}>
                    {packageDetail.package_id.package}
                  </option>
                ))}
              </Select>
            </Form.Item>
          )}

          <Form.Item style={{ marginBottom: "16px" }} name={"department"} className="emp-modal__form-item">
            <Select
              className="emp-modal__select"
              style={{ width: "100%" }}
              placeholder="Select employee department"
              optionFilterProp="children"
              onChange={handleChange}
            >
              {allDepartment?.map((item: any, index: any) => (
                <Option value={item.name} key={index}>{item.name}</Option>
              ))}
            </Select>
          </Form.Item>

          {/* File upload */}
          {getUserByID?.is_payment !== false && (
            <AppUpload
              kind="file"
              accept=".csv"
              label="Upload CSV file"
              hint=".csv files only"
              fileName={csvFile?.name}
              handleFileUpload={handleFileChange}
            />
          )}

          {/* Note */}
          <div className="emp-modal__note">
            <span>💡</span>
            <p>Select the department and package, fill in the employee details using the CSV template, and upload the file.</p>
          </div>

          {/* Error */}
          {csvNotAllowed && (
            <div className="emp-modal__error">
              <span>⚠️</span>
              <p>{csvError}</p>
            </div>
          )}

          {/* Submit */}
          <button className="emp-btn emp-btn--primary emp-btn--full emp-btn--magenta" onClick={UploadCSVFile}>
            {isLoding ? (
              <><span className="emp-btn__spinner" /> Processing...</>
            ) : (
              <><span>📤</span> Import CSV</>
            )}
          </button>
        </div>
      </AppModal>

      {/* ── User Limit Modal ─────────────────────────────────────── */}
      <AppModal
        open={userLimitOver}
        onCancel={UserLimitOverCancel}
        className="emp-modal"
      >
        <div className="emp-modal__inner emp-modal__inner--center">
          <img src="/Group14181.svg" alt="" width={64} height={64} style={{ marginBottom: 16 }} />
          <h3 className="emp-modal__title">Employee Limit Reached</h3>
          <p className="emp-modal__desc">
            Reach out to us today to upgrade your SOULSARA plan and add more employee slots, unlocking enhanced well-being for your team!
          </p>
          <a
            href="https://www.soulsara.world/contact-us"
            target="_blank"
            rel="noreferrer"
            className="emp-btn emp-btn--primary emp-btn--full emp-btn--magenta"
            style={{ textDecoration: "none", display: "flex", marginTop: 8 }}
          >
            Contact Us
          </a>
        </div>
      </AppModal>
    </div>
  );
}

export default Employees;